import { render, staticRenderFns } from "./InstallationEdit.vue?vue&type=template&id=c11c36b0&scoped=true"
import script from "./InstallationEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstallationEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/css/scoped/expansion-container-style.css?vue&type=style&index=0&id=c11c36b0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11c36b0",
  null
  
)

/* custom blocks */
import block0 from "@/components/customers/locales/i18n-installation-edit.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fcustomers%2Fchildren%2FInstallationEdit.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports